const __vite_glob_0_172 = "<svg width=\"23\" height=\"22\" viewBox=\"0 0 23 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path\n    d=\"M0.130859 0V10.4573H10.5882V0H0.130859ZM11.6754 0V10.4573H22.1309V0H11.6754ZM0.130859 11.5445V22H10.5882V11.5445H0.130859ZM11.6754 11.5445V22H22.1309V11.5445H11.6754Z\" />\n</svg>\n";

export { __vite_glob_0_172 as default };
